import { ingenuity } from "@quest/base-core";
import { PlayerMsgView } from "@quest/murka-games-behavior-leopard/dist";
import { GameParserModel } from "../Platform/GameParserModel";

export class PlayerMsgViewGame extends PlayerMsgView {
   public showTotalWinMsgInFgBroken(): void {
        let totalFreeGameWin;
        if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
            (ingenuity.parserModel as GameParserModel).setTotalBaseGameWinAmt((ingenuity.parserModel as GameParserModel).getBaseGameWinAmt());
        }
        // else{
        //     (ingenuity.parserModel as GameParserModel).setTotalBaseGameWinAmt((ingenuity.parserModel as GameParserModel).getGameWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt());
        // }


        if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
            totalFreeGameWin = (ingenuity.parserModel as GameParserModel).getFreeSpinAccumulatedWinAmt() + (ingenuity.parserModel as GameParserModel).getTotalBaseGameWinAmt();
        }
        else {
            totalFreeGameWin = (ingenuity.parserModel as GameParserModel).getFreeSpinWinAmt() + (ingenuity.parserModel as GameParserModel).getTotalBaseGameWinAmt();
            //Scenario- Deducting jackpot win amount from total amount when line win occurs on last freespin and jackpot win is
            //also awarded for both normal game and broken game
            if((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() === 0 && (ingenuity.parserModel as GameParserModel).getIsJackpotAward()){
                totalFreeGameWin = totalFreeGameWin - (ingenuity.parserModel as GameParserModel).getTotalJackpotWinFG();
            }
        }
        this.setValueInTotalWinMeter(totalFreeGameWin.toString());
    }
}